import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MtxGridModule } from '@ng-matero/extensions/grid';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  IAddButtonConfig,
  ITableConfig,
  ITableFilterConfig,
  ITableGridConfig,
  ITablePagingConfig,
  ITableSelectConfig,
} from '@shared/components/table-base/table-base.types';

@Component({
  selector: 'app-selected-uses',
  imports: [CommonModule, MtxGridModule, MatDatepickerModule, TranslateModule],
  template: `
    <div style="margin-bottom: 40px;">
      <h2 [style]="props?.attributes?.headerStyle">
        {{ 'area_return.label__selected_uses' | translate }}
      </h2>
      <mtx-grid
        [columnResizable]="true"
        [columns]="props.columns"
        [data]="props.data$ | async"
        [pageOnFront]="false"
        [rowStriped]="true"
        [rowHover]="false"
        [cellSelectable]="false"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [columnHideable]="true"
        [showColumnMenuButton]="true"
        [columnMenuButtonText]="'grid.columns_shown' | translate"
        [columnMenuHeaderText]="'grid.columnMenuHeaderText' | translate"
        [noResultText]="props?.noResultsText ?? 'grid.no_results' | translate"
        columnMenuButtonClass="col-button"
        [showSidebar]="true"
        [showToolbar]="true"
        [columnSortable]="true"
        [showColumnMenuButton]="true"
        columnMenuButtonType="flat"
        [columnPinnable]="false">
      </mtx-grid>
    </div>
  `,
})
export class SelectedUsesComponent extends FieldType {
  config: ITableConfig = <ITableConfig>{
    title: '',
    translatePath: '',
    addButton: <IAddButtonConfig>{
      disabled: true,
    },
    grid: <ITableGridConfig>{
      showToolbar: true,
      columnResizable: true,
      paging: <ITablePagingConfig>{
        pageIndex: 0,
        pageSize: 50,
        showPaginator: true,
      },
      filter: <ITableFilterConfig>{
        filterVisible: false,
        sortOnFront: false,
        filterOptions: {},
      },
      select: <ITableSelectConfig>{
        rowSelectable: true,
        multiSelectable: true,
      },
    },
  };
}
